import { hotArticlesTop10 } from '@/api/dynamic'

const state = {
  a: '1111',
  hotspot: [] // 行业热点
}

const mutations = {
  setHotspot(state, payload) {
    state.hotspot = payload
  },
  setA(state, payload) {
    state.a = payload
  }
}

const actions = {
  async actionHotArticlesTop10({ commit }) {
    commit('setA', '2222')
    const list = await hotArticlesTop10()
    commit('setHotspot', list)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
